import { IGetFieldsBody, IGetFormFieldsBody } from './types'

import { request } from '@/utils/request'

const GET_FIELDS_URL = '/api/node/fields'
const GET_FORM_FIELDS_URL = '/api/form/fields'

export const getFields = (body: IGetFieldsBody) => {
  return request(GET_FIELDS_URL, {
    method: 'POST',
    body: JSON.stringify(body)
  })
}

export const getFormFields = (body: IGetFormFieldsBody) => {
  return request(GET_FORM_FIELDS_URL, {
    method: 'POST',
    body: JSON.stringify(body)
  })
}
